module.exports = __webpack_public_path__ + "media/images/habit-icon-3afb66a0ca7763d9fdfce51a5b2a3fd8.svg";